import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { TemplateControlValue } from '../../../../tamalelibs/models/template-control-value.model';

@Component({
    selector: 'tam-template-area',
    templateUrl: './template-area.component.html',
    styleUrls: ['./template-area.component.scss']
})
export class TemplateAreaComponent implements OnInit {
    @Input() childConfig: any;
    @Input() valueChangeSubject: Subject<TemplateControlValue>;
    constructor() { }

    ngOnInit() {
    }

}
